module.exports = __webpack_public_path__ + "vipps.29af43221e961311b292.jpg";